<p-messages [(value)]="messages"
            [showTransitionOptions]="showTransitionOptions"
            [hideTransitionOptions]="hideTransitionOptions"
            [enableService]="enableService"
            [closable]="closable"
            [ngClass]="lang === 'ar' ? 'message-rtl' : ''"></p-messages>
